<template>
  <div
    class="fact-block"
    :class="themeColor"
  >
    <div
      v-if="label || isEditable"
      class="tag-wrapper"
    >
      <div class="tags tags-sm theme__color--label">
        <span v-edit="'Label'">
          {{ label }}
        </span>
      </div>
      <svgicon
        name="Misc/LabelAngle24"
        class="angle-right"
      />
    </div>
    <wysiwyg
      v-if="content || isEditable"
      v-edit="'Content'"
      class="fact-block__wysiwyg"
      :content="content"
    />
  </div>
</template>

<script>
import "#/Misc/LabelAngle24"

export default {
  name: "FactBlock",
  props: {
    theme: {
      type: String,
      default: "Default"
    },
    label: {
      type: String,
      default: ""
    },
    content: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    themeColor () {
      return `theme__color--${this.theme}`
    }
  }
}
</script>

<style lang="scss">
.fact-block {
  padding: 3.5rem 1.5rem 2rem;
  position: relative;
  margin: 0 0.5rem 2rem;

  @include media-breakpoint-up(md) {
    margin: 0 0 3rem;
    padding: 4rem 3.5rem 2.5rem;
  }

  @include media-breakpoint-up(lg) {
    padding: 4rem 5rem 2.5rem;
  }

  @include media-breakpoint-up(xl) {
    padding: 4rem 6.5rem 2.5rem;
  }

  &__wysiwyg {
    ul li::before {
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSIjM2EzYTNhIj4NCiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjUuOTA5NjE3LDkuMDI4NTExNzggTDI0LjczOTM5MDEsOC4wNTk1MTE3OCBDMjQuNjMyMTcwMyw3Ljk2OTUxMTc4IDI0LjQ3MTg1MTMsNy45ODM1MTE3OCAyNC4zODA5Njk4LDguMDg4NTExNzggTDEzLjc0NjgxMjksMjAuNDUyNTExOCBMNy42MTk5NzAwOCwxMy4wODg1MTE4IEM3LjUyOTA4ODU4LDEyLjk4MjUxMTggNy4zNjc3NDgzOCwxMi45Njk1MTE4IDcuMjYwNTI4NjQsMTMuMDU4NTExOCBMNi4wOTAzMDE2NiwxNC4wMjc1MTE4IEM1Ljk4MjA2MDc3LDE0LjExNjUxMTggNS45Njk4MDcwOCwxNC4yNzQ1MTE4IDYuMDYwNjg4NTgsMTQuMzgwNTExOCBMMTIuOTY1NjQwNCwyMi42NDQ1MTE4IEMxMy4zNzQwOTY2LDIzLjExNzUxMTggMTQuMTE5NTI5MiwyMy4xMTc1MTE4IDE0LjUyNzk4NTQsMjIuNjQ0NTExOCBMMjUuOTM5MjMwMSw5LjM4MDUxMTc4IEMyNi4wMzExMzI4LDkuMjc1NTExNzggMjYuMDE2ODM2OCw5LjExNzUxMTc4IDI1LjkwOTYxNyw5LjAyODUxMTc4Ii8+DQo8L3N2Zz4=") !important;
    }

    h3 {
      margin-bottom: 0.5rem;
    }

    p {
      margin-bottom: 1.5rem;
    }
  }

  .tag-wrapper {
    position: absolute;
    top: 1rem;
    left: 0;

    @include font(text, 3, "black");

    .angle-right {
      width: 1.25rem;
      height: 1.5rem;
      margin-left: -0.0625rem;
    }
  }
}
</style>
